import makeStyles from "@material-ui/core/styles/makeStyles";
import "@fontsource/montserrat";

const useStyles = makeStyles((theme) => ({
  root: { minHeight: "500px", paddingTop: "20px", paddingBottom: "30px" },
  firstHeading: {
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "rgba(0,0,0,0.5)",
    fontSize: "18px",
  },
  secondHeading: {
    fontFamily: "Montserrat",
    color: "#6f59a6",
    fontSize: "40px",
    fontWeight: "bold",
  },
  upperDisplay: {
    width: "86%",
    marginTop: "25px",
    padding: "25px 50px",
    background:
      "linear-gradient(90deg, rgba(222, 212, 245,0.8130602582830007) 0%, rgba(247,243,255,1) 100%)",
  },
  messageIconWrapper: {
    height: "100%",
    display: "flex",
    justifyContent: "left",
    alignItems: "center",
    borderRadius: "px",
  },
  headingOne: {
    fontSize: "28px",
    fontWeight: 600,
    fontFamily: "Montserrat",
    color: "#3e4a59",
  },
  headingTwo: {
    color: "rgba(86, 58, 150, 1)",
    fontSize: "40px",
    fontWeight: "600",
    fontFamily: "Montserrat",
  },
  requestsStatusTy: {
    backgroundColor: "#816aaf",
    color: "white",
    fontFamily: "Montserrat",
    padding: "10px 10px",
    borderRadius: "8px",
    fontWeight: 600,
    width: '100%'
  },
  lineWithDotContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginLeft: "20px",
    marginLeft:"2rem"
  },
  cursorOnHover: {
    "&:hover": {
      cursor: "pointer",
    },
    marginLeft: "40px",
  },
  cardLabelText1: {
    textAlign: "left",
    fontSize: "14px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#6f59a6",
    opacity: 0.9,
  },
  cardLabelText2: {
    textAlign: "left",
    fontSize: "14px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#3e4a59",
  },
  viewProfileButtonContainer: {
    width: '100%',
    marginTop: "-40px",
  },
  viewProfileButton: {
    textTransform: "none",
    padding: "5px 25px",
    borderRadius: "20px",
    backgroundColor: "#b499c7",
    color: "#fff",
    fontSize: "18px",
    fontWeight: "bold",
    fontFamily: "Montserrat",
    marginTop: "25px",
    transition: "0.5s",
    "&:hover": {
      transform: "translateY(-10px)",
    },
  }, 
  mentorCardContainer: {
    padding: '40px 7%',
    [theme.breakpoints.down('md')]: {
      padding: '10px 7%',
    }
  },
  downIcon: {
    [theme.breakpoints.down('md')]: {
      marginTop: '50px'
    }
  },
  cardroot: {
    paddingTop: "50px",
    // background:
    // "linear-gradient(256deg, rgba(244,240,255,1) 0%, rgba(211,191,255,0.55) 100%)",
    background: "linear-gradient(77deg, #d9c5e789 0%, #f4f4f4 74%)",
    position: 'relative'
  },
  mentorIdContainer: {
    position: 'absolute', 
    top: 0, 
    left: 0, 
    width: '100%',
    backgroundColor: '#b499c7',
    padding: '10px 0', 
    transition: '0.5s',
    '&:hover': {
      backgroundColor: '#816aaf',
      cursor: 'pointer'
    }
  },
  mentorId: {
    fontFamily: 'Montserrat', 
    fontWeight: 'bold', 
    color: '#fff', 
    fontSize: '14px'
  },
  cardImage: {
    height: "150px",
    width: "150px",
    objectFit: "cover",
    borderRadius: "5px",
    boxShadow: "3px 4px 13px -4px rgba(0,0,0,0.75)",
    objectFit: "contain",
    marginBottom: '30px'
  },
  cardText1: {
    paddingTop: "30px",
    fontSize: "18px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#6f59a6",
    opacity: 0.9,
  },
  tooltip: {
    backgroundColor: "rgba(118,95,170,1)",
    padding: "10px",
    maxWidth: "none",
    [theme.breakpoints.down('md')]:{
      display:'none',
    }
  },
  tooltipArrow: {
    backgroundColor: "rgba(118,95,170,1)",
  },
  cardText3: {
    paddingTop: "14px",
    fontSize: "14px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#6f59a6",
    opacity: 0.9,
  },
  cardText2: {
    fontSize: "26px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#6f59a6",
  },
  lineWithDotUpper2: {
    color: "#277acc",
    textAlign: "left",
    fontWeight: "bold",
    fontSize: "18px",
    marginLeft:"4rem"
  },
  lineWithDot2: {
    maxWidth: "none",
    maxHeight: "none",
    width: "150px",
    height: "10px",
    marginLeft: "4rem",
  },
  circularDisplay: {
    height: "50px",
    width: "50px",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background:
      "linear-gradient(45deg, rgba(83,255,250,1) 0%, rgba(118,95,170,1) 100%)",
    color: "#fff",
    fontWeight: "bold",
  },
  dividerInCollapse: {
    margin: '15px 0'
  },
  filterContainer2: {
    padding: "10px",
    display: "flex",
  },
  select: {
    fontSize: "16px",
  },
  rightRotated: { transform: "rotate(-90deg)" },
  downIcon: {
    [theme.breakpoints.down("md")]: {
      marginTop: "50px",
    },
  },
  statusContainer: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      justifyContent: 'center'
    }
  },
  statusUnselected: {
    fontFamily: "Montserrat",
        fontSize: "18px",
        fontWeight: "bold",
        color: "#838186",
        marginLeft: "4rem",
        [theme.breakpoints.down('md')]: {
         marginLeft: 0,
         marginTop: '10px'
        }   
  },
  lineWithDotUpper: {
    color: "#277acc",
    textAlign: "left",
    fontWeight: "bold",
    fontSize: "18px",
  },
  lineWithDotUpper2: {
    color: "#277acc",
    textAlign: "left",
    fontWeight: "bold",
    fontSize: "18px",
    marginLeft: "4rem",
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
      marginTop: '20px'
    }
  },lineWithDot: {
    maxWidth: "none",
    maxHeight: "none",
    width: "150px",
    height: "10px",
    marginLeft: 0,
  },
  lineWithDot2: {
    maxWidth: "none",
    maxHeight: "none",
    width: "150px",
    height: "10px",
    marginLeft: "4rem",
    [theme.breakpoints.down('md')]: {
      marginLeft: 0
    }
  },
}));

export default useStyles;
